import styled from 'styled-components';

import Heading from '../../components/Heading/Heading.styled';

export const ThankYouPageWrapperStyled = styled.div`
  padding: 0 20px;
  margin: 40px auto 0;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const TitleStyled = styled(Heading)`
  ${({ theme }) => `
    color: ${theme.primaryColour};

    ${theme.devices.mobile} {
      font-size: ${theme.fontSizes.large};
    }
  `}
`;

export const ImageStyled = styled.img`
  max-width: 630px;
  max-height: 320px;
  width: 100%;
  display: block;
  margin: 20px auto;
`;

export const FeedbackWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;

  ${({ theme }) => `
    a {
      color: ${theme.textColour};
      text-decoration: underline;
    }
  `}
`;

export const InnerWrapperStyled = styled.div`
  max-width: 800px;
`;

export const ThankYouDescriptionStyled = styled.p`
  ${({ theme }) => `
    color: ${theme.textColour};
  `}
`;
